import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { pushBackHandler, popBackHandler } from '../../utils/backHandler';

export default function PromoLeaveConfirmModal({ isOpen, onConfirm, onCancel }) {
    useEffect(() => {
        if (!isOpen) return;
        pushBackHandler(onCancel);
        return () => popBackHandler(onCancel);
    }, [isOpen, onCancel]);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-[200] flex items-center justify-center px-6 pointer-events-none"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2, ease: 'easeOut' }}
                >
                    <motion.div
                        className="absolute inset-0 bg-black/45 pointer-events-auto"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                        onClick={onCancel}
                    />

                    <motion.div
                        className="relative z-10 w-full max-w-[280px] rounded-[12px] border border-[#353232] bg-[#1A1A1A] px-4 py-4 pointer-events-auto shadow-[0_12px_40px_rgba(0,0,0,0.45)]"
                        initial={{ opacity: 0, scale: 0.9, y: 8 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.92, y: 6 }}
                        transition={{ duration: 0.24, ease: [0.32, 0.72, 0, 1] }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex items-start gap-3 mb-4">
                            <div className="w-[36px] h-[36px] shrink-0 rounded-full bg-[#fb2c36]/12 border border-[#fb2c36]/25 flex items-center justify-center">
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#fb2c36"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden
                                >
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                                </svg>
                            </div>
                            <div className="min-w-0 pt-0.5">
                                <h3 className="text-white text-[14px] font-semibold font-roboto leading-[18px]">
                                    Quit this Promo?
                                </h3>
                                <p className="text-[#959595] text-[12px] leading-[16px] mt-1 font-roboto">
                                    Changes will be lost.
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-row gap-2">
                            <button
                                type="button"
                                onClick={onCancel}
                                className="flex-1 h-[36px] rounded-[8px] border border-[#353232] bg-[#121212] text-white text-[13px] font-medium font-roboto active:bg-white/5 transition-colors"
                            >
                                Stay
                            </button>
                            <button
                                type="button"
                                onClick={onConfirm}
                                className="flex-1 h-[36px] rounded-[8px] border border-[#fb2c36]/35 bg-[#fb2c36]/10 text-[#fb2c36] text-[13px] font-medium font-roboto active:bg-[#fb2c36]/20 transition-colors"
                            >
                                Quit
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
